import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function ConsultarTecnicos() {

    const { permisos, setSubModuloActual, setTecnicoSeleccionado, logout } = useGlobal();
    const [tecnicos, setTecnicos] = useState([]);
    const [mensaje, setMensaje] = useState("");
    const [seleccionado, setSeleccionado] = useState(null);
    const apiFetch = useApiFetch();

    const tienePermisoConsultar = permisos.includes(6); // 6 = ID permiso "Consultar técnicos"

    // Efecto secundario para validar que el tiene permiso
    useEffect(() => {
        if (tienePermisoConsultar) {
            const cargarTecnicos = async () => {
                try {
                    const data = await apiFetch("consultar_tecnicos.php", { method: "GET" }, logout);

                    if (data.status === "ok") {
                        setTecnicos(data.tecnicos || []);
                    } else {
                        setMensaje(data.message || "No se pudieron cargar los técnicos.");
                    }
                } catch {
                    setMensaje("Error al cargar técnicos.");
                }
            };

            cargarTecnicos();
        }
    }, [tienePermisoConsultar]);

    if (!tienePermisoConsultar) {
        return <p>Acceso denegado. No tiene permiso para consultar técnicos.</p>;
    }

    // Exportar en CSV
    const handleExportar = async () => {
        if (tecnicos.length === 0) return;

        let headers = [];
        let rows = [];

        try {
            if (seleccionado === null) {
                // Exportar todos los técnicos
                headers = ["ID Técnico", "Rol", "Nombre completo"];
                rows = tecnicos.map(t => [t.id_tecnico, t.rol, t.nombre_completo]);
            } else {
                // Exportar solo el técnico seleccionado con datos enriquecidos con otras tablas (más detalaldo)
                const data = await apiFetch(`consulta_6.php?id_tecnico=${seleccionado}`, {
                    method: "GET"
                }, logout);

                if (data.status === "ok") {
                    const tec = data.tecnico;

                    headers = [
                        "ID Usuario",
                        "Usuario",
                        "Apellido Paterno",
                        "Apellido Materno",
                        "Correo",
                        "Cargo",
                        "Dirección",
                        "Acrónimo",
                        "Calle",
                        "Número Ext.",
                        "Colonia",
                        "Alcaldía",
                        "Código Postal",
                        "Ciudad",
                        "Edificio",
                        "Nivel",
                        "Rol",
                        "Permisos"
                    ];

                    rows = [[
                        tec.id_usuario,
                        tec.usuario,
                        tec.a_paterno,
                        tec.a_materno,
                        tec.correo,
                        tec.cargo,
                        tec.direccion_a,
                        tec.acronimo,
                        tec.calle,
                        tec.num_ext,
                        tec.colonia,
                        tec.alcaldia,
                        tec.cod_pos,
                        tec.ciudad,
                        tec.edificio,
                        tec.nivel,
                        tec.rol,
                        (tec.permisos || []).join("; ")
                    ]];
                } else {
                    alert("Error al consultar técnico: " + data.message);
                    return;
                }
            }

            // Función para escapar valores CSV y exportar correctamente los campos
            const escapeCSV = (value) => {
                if (value === null || value === undefined) return "";
                const str = value.toString();
                // Si contiene coma, salto de línea o comillas, se envuelve en comillas dobles, para que no desfase las columnas vs los valores
                if (/[",\r\n]/.test(str)) {
                    return `"${str.replace(/"/g, '""')}"`;
                }
                return str;
            };

            // Generar CSV
            let csvContent = "\uFEFF";
            csvContent += headers.map(escapeCSV).join(",") + "\r\n";
            rows.forEach(r => {
                csvContent += r.map(escapeCSV).join(",") + "\r\n";
            });

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "tecnicos.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            alert("Error al exportar: " + error.message);
        }
    };

    // Exportar en PDF
    const handleExportarPDF = () => {
        if (tecnicos.length === 0) return;

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de Técnicos", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla con columnas visibles
        autoTable(doc, {
            startY: 50,
            head: [["ID Técnico", "Rol", "Nombre completo"]],
            body: tecnicos.map(t => [t.id_tecnico, t.rol, t.nombre_completo])
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("reporte_tecnicos.pdf");
    };


    const handleModificar = () => {
        if (seleccionado) {
            setTecnicoSeleccionado(seleccionado);
            setSubModuloActual("Modificar Técnicos");
        }
    };

    const handleEliminar = () => {
        if (seleccionado) {
            setTecnicoSeleccionado(seleccionado);
            setSubModuloActual("Eliminar Técnicos");
        }
    };

    return (
        <div className="sesion-form">
            <h2>Lista de Técnicos</h2>
            {mensaje && <p className="error">{mensaje}</p>}
            {/* Se muestra la tabla solo con ciertos campos*/}
            <table className="tabla-estandar seleccion-unica">
                <thead>
                    <tr>
                        <th>Seleccionar</th>
                        <th>ID Técnico</th>
                        <th>Rol</th>
                        <th>Nombre completo</th>
                    </tr>
                </thead>
                <tbody>
                    {tecnicos.map((tec) => (
                        <tr key={tec.id_tecnico}>
                            <td data-label="Seleccionar">
                                <input
                                    type="checkbox"
                                    checked={seleccionado === tec.id_tecnico}
                                    onChange={() => {
                                        const nuevo = seleccionado === tec.id_tecnico ? null : tec.id_tecnico;
                                        setSeleccionado(nuevo);
                                        console.log("Seleccionado:", nuevo);
                                    }}
                                />
                            </td>
                            <td data-label="ID Técnico">{tec.id_tecnico}</td>
                            <td data-label="Rol">{tec.rol}</td>
                            <td data-label="Nombre completo">{tec.nombre_completo}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="form-buttons">
                <button disabled={!seleccionado} onClick={handleModificar}>Modificar<br></br>Técnico</button>
                <button disabled={!seleccionado} onClick={handleEliminar}>Eliminar<br></br>Técnico</button>
                <button className="exportar" onClick={handleExportar}>Exportar<br></br>en CSV</button>
                <button className="exportar" onClick={handleExportarPDF}>Exportar<br></br>en PDF</button>

            </div>
        </div>
    );
}

export default ConsultarTecnicos;